<template>
  <!--tyle="clear: both" 这样可以看到浮动的元素-->
  <div class="container" style="clear: both">
    <!--标签,类似笔的形状-->
    <div class="personal-right-inner-pen-panel">
      <span class="personal-right-inner-pen">
        <span class="pen-left"></span>
        {{ text }}
        <span class="pen-right"></span>
      </span>
      <span v-if="closAble" id="closAbleTag" ref="closAbleTag" class="closAbleTag iconfont" @click="closAbleHandler()"></span>
      <div class="pen-container" id="pen-container" ref="penPanel">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    text: {
      type: String,
    },
    closAble: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      closeStatus: false,
      customHeight: '0px',
    }
  },
  mounted() {
    this.initPage()

  },
  methods: {

    initPage() {
      this.customHeight = this.$refs.penPanel.offsetHeight + 'px'
      //需要自己处理兼容性问题(@-webkit-keyframes 与 @keyframes)
      // js创建@keyframes，的位置
      //${this.customHeight}加上是为了区分 否则样式会出现覆盖的情况
      const runkeyframes = `

      .panelToBig${this.customHeight} {
        animation-fill-mode: forwards;
        animation-name: panelToBig${this.customHeight};
        animation-duration: 300ms;
        -webkit-animation-fill-mode: forwards;
        -webkit-animation-name: panelToBig${this.customHeight};
        -webkit-animation-duration:  300ms;
        -moz-animation-fill-mode: forwards;
        -moz-animation-name: panelToBig${this.customHeight};
        -moz-animation-duration:  300ms;
        -o-animation-fill-mode: forwards;
        -o-animation-name: panelToBig${this.customHeight};
        -o-animation-duration:  300ms;

      }

      .panelToSmall${this.customHeight} {
        animation-fill-mode: forwards;
        animation-name: panelToSmall${this.customHeight};
        animation-duration: 300ms;
        -webkit-animation-fill-mode: forwards;
        -webkit-animation-name: panelToSmall${this.customHeight};
        -webkit-animation-duration:  300ms;
        -moz-animation-fill-mode: forwards;
        -moz-animation-name: panelToSmall${this.customHeight};
        -moz-animation-duration:  300ms;
        -o-animation-fill-mode: forwards;
        -o-animation-name: panelToSmall${this.customHeight};
        -o-animation-duration:  300ms;
      }

        @keyframes panelToSmall${this.customHeight} {
          0% {
            height: ${this.customHeight};
          }

          100% {
            height: 0;
          }
        }
      }
      @-webkit-keyframes panelToSmall${this.customHeight} {
          0% {
            height: ${this.customHeight};
          }

          100% {
            height: 0;
          }
        }
      }

      @-moz-keyframes panelToSmall${this.customHeight} {
          0% {
            height: ${this.customHeight};
          }

          100% {
            height: 0;
          }
        }
      }

      @-o-keyframes panelToSmall${this.customHeight} {
          0% {
            height: ${this.customHeight};
          }

          100% {
            height: 0;
          }
        }
      }

      @keyframes panelToBig${this.customHeight} {
        0% {
          height: 0;
        }
        100% {
          min-height: ${this.customHeight};
        }
     }

      @-webkit-keyframes panelToBig${this.customHeight} {
        0% {
          height: 0;
        }
        100% {
          min-height: ${this.customHeight};
        }
     }

     @-moz-keyframes panelToBig${this.customHeight} {
        0% {
          height: 0;
        }
        100% {
          min-height: ${this.customHeight};
        }
     }

      @-o-keyframes panelToBig${this.customHeight} {
        0% {
          height: 0;
        }
        100% {
          min-height: ${this.customHeight};
        }
     }
     `
      // 创建style标签
      const style = document.createElement('style');
      // 设置style属性
      style.type = 'text/css';
      // 将 keyframes样式写入style内
      style.innerHTML = runkeyframes;
      // 将style样式存放到head标签
      document.getElementsByTagName('style')[0].parentElement.appendChild(style);
     if (this.closAble){
       this.closAbleHandler()
     }
    },

    //关闭标签的关闭事件
    closAbleHandler(status) {
      // 关闭面板
      if (this.closeStatus || status) {
        //按钮的动画
        this.$refs.closAbleTag.classList.remove("closAbleTagReRotate")
        this.$refs.closAbleTag.classList.add("closAbleTagRotate")

        //面板的动画
        this.$refs.penPanel.classList.remove(`panelToBig${this.customHeight}`)
        this.$refs.penPanel.classList.add(`panelToSmall${this.customHeight}`)

      } else {
        //打开面板
        this.$refs.closAbleTag.classList.remove("closAbleTagRotate")
        this.$refs.closAbleTag.classList.add("closAbleTagReRotate")

        //面板的动画
        this.$refs.penPanel.classList.remove(`panelToSmall${this.customHeight}`)
        this.$refs.penPanel.classList.add(`panelToBig${this.customHeight}`)

      }
      if (status){
        this.closeStatus=false
      }else{
        this.closeStatus = !this.closeStatus
      }


    }
  }
}
</script>

<style id="PenStyle" scoped>
/*标签,类似笔的形状*/
.personal-right-inner-pen-panel {
  position: relative;
  width: 100%;
  background-color: #eef5fc;
  border-radius: 10px;

}

.personal-right-inner-pen {
  color: white;
  line-height: 40px;
  font-size: 18px;
  position: relative;
  display: inline-block;
  width: 150px;
  height: 40px;
  background-color: #3ad4ee;
  border-radius: 11px 5px 5px 11px;
  /*将左边的下三角箭头放在框外面*/
  left: -20px;
}

.pen-left {
  /*设置对齐方式,否则可能文字不对齐*/
  vertical-align: top;
  transform: rotate(-30deg);
  position: relative;
  top: 20px;
  left: 5px;
  width: 16px;
  height: 16px;
  display: inline-block;
  border: 16px #3ad4ee solid;
  border-color: transparent;
  /*三角形*/
  border-left-color: #3ad4ee;
  border-radius: 4px;

}

.pen-right {
  /*设置对齐方式,否则可能文字不对齐*/
  vertical-align: top;
  float: right;
  position: relative;
  left: 37px;
  width: 20px;
  height: 20px;
  display: inline-block;
  border: 20px #3ad4ee solid;
  border-color: transparent;
  /*三角形*/
  border-left-color: #3ad4ee;
  border-radius: 4px;
}

.pen-right:before {
  content: '';
  position: relative;
  top: -20px;
  left: -15px;
  display: inline-block;
  width: 2px;
  height: 40px;
  background-color: #eef5fc;

}

.pen-right:after {
  content: '';
  position: relative;
  top: -74px;
  left: -8px;
  display: inline-block;
  width: 2px;
  height: 40px;
  background-color: #eef5fc;

}


.container {
  width: 100%;
  padding: 20px 0;
  position: relative;
  background-color: white;

}

.closAbleTag {
  position: relative;
  /*设置对齐方式,否则可能文字不对齐*/
  /*vertical-align: top;*/
  float: right;
  margin: 0 30px;
}

.closAbleTag:before {
  text-align: center;
  display: inline-block;
  height: 40px;
  width: 60px;
  cursor: pointer;
  line-height: 40px;
  content: '\e601';
  color: #3ad4ee;
  font-weight: bold;
  font-size: 20px;
}

.closAbleTagRotate {
  transform: rotate(0deg);
  transition-duration: 300ms;
}

.closAbleTagReRotate {
  transform: rotate(180deg);
  transition-duration: 300ms;
}

.pen-container {
  background-color: white;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/custom/Pen.vue